var v1="<div class=\"lbaToast\" ng-show=\"vm.showToast\" ng-switch=\"vm.messageType\"> <span class=\"lbaToast_error\" ng-switch-when=\"error\"><i class=\"fa fa-frown-o lbaToast_errorIcon\"></i> {{ vm.message }}</span>\n<span class=\"lbaToast_success\" ng-switch-when=\"success\"><i class=\"fa fa-smile-o lbaToast_successIcon\"></i> {{ vm.message }}</span>\n<span class=\"lbaToast_waiting\" ng-switch-default><i class=\"fa fa-circle-o-notch lbaToast_waitingIcon\"></i> {{ vm.message }}</span> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaToast.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaToast/lbaToast.html
// module id = 186
// module chunks = 0